import styled from 'styled-components';
import { normalizeWidth } from '../../../../utils/normalize';

export const Container = styled.div`
  background-color: rgba(252, 252, 252, 1);
  position: absolute;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  padding: 16px;
  width: 216px;
  gap: 16px;
  box-shadow: 0px 2px 8px 0px rgba(27, 27, 27, 0.24);
`;

export const Button = styled.button<{ delete: boolean }>`
  background: none;
  display: flex;
  flex-direction: row;
  gap: 8px;
  border: none;
  font-size: 14px;
  font-family: Inter-Regular;
  color: ${(props) => (props.delete ? 'rgba(243, 51, 51, 1)' : 'rgba(49, 49, 49, 1)')};
  cursor: pointer;
  align-items: center;
`;